/**
 * @var events array The list of selected events
 * output example [{label:'Dominer le changement', value:'dominer....'},{label:'', value:''}]
*/
export const eventSelected = (events) => {
    console.log(events);
    //Other code
};

/**
 * @var cities array The list of selected cities
 * output example [{label:'Chicoutimi', value:'chicotimi'},{label:'', value:''}...]
*/
export const citiesSelected = (cities) => {
    console.log(cities);
    //Other code

};

/**
 * @var month string The selected month
 * output example: {label: "Avril", value: "April"}
*/
export const monthSelected = (month) => {
    console.log(month);
    //Other code

};



/** WEBPACK FOOTER **
 ** ./src/components/statistics/index.js
 **/